export const INQUIRY_LOADS_STATUSES: { alias: string; parentStatus?: string; title: string }[] = [
  {
    alias: 'to_be_quoted',
    title: 'To be quoted',
  },
  {
    alias: 'contact_me',
    parentStatus: 'to_be_quoted',
    title: 'Contact me',
  },
  {
    alias: 'check_rate',
    parentStatus: 'to_be_quoted',
    title: 'Check rate',
  },
  {
    alias: 'get_info',
    parentStatus: 'to_be_quoted',
    title: 'Get info',
  },
  {
    alias: 'shit',
    parentStatus: 'to_be_quoted',
    title: 'Shit',
  },
  {
    alias: 'quoted',
    title: 'Quoted',
  },
  {
    alias: 'confirmed',
    title: 'Confirmed',
  },
  {
    alias: 'to_be_confirmed',
    title: 'To be confirmed',
  },
  {
    alias: 'expired',
    title: 'Expired',
  },
  {
    alias: 'cancelled',
    title: 'Cancelled',
  },
]

export const LOAD_STATUSES = [
  {
    alias: 'confirmed',
    isAdmin: false,
    title: 'Confirmed',
  },
  {
    alias: 'to_cover',
    isAdmin: true,
    parentStatus: 'confirmed',
    title: 'To cover',
  },
  {
    alias: 'set_up',
    isAdmin: true,
    parentStatus: 'confirmed',
    title: 'Set up',
  },
  {
    alias: 'busy',
    isAdmin: true,
    parentStatus: 'confirmed',
    title: 'Busy',
  },
  {
    alias: 'covered',
    isAdmin: true,
    parentStatus: 'confirmed',
    title: 'Covered',
  },
  {
    alias: 'at_pickup',
    isAdmin: false,
    title: 'At pick up',
  },
  {
    alias: 'in_transit',
    isAdmin: false,
    title: 'In transit',
  },
  {
    alias: 'at_drop_off',
    isAdmin: false,
    title: 'At drop off',
  },
  {
    alias: 'completed',
    isAdmin: false,
    title: 'Completed',
  },
  {
    alias: 'issue',
    isAdmin: false,
    title: 'Issue',
  },
  {
    alias: 'cancelled',
    isAdmin: false,
    title: 'Cancelled',
  },
]
